import React from 'react'
import { createPortal } from 'react-dom'
import { Modal, Form, Button, Row, Col } from 'react-bootstrap'
import useReflectionPromptMutation from './use-reflection-prompt-mutation'
import Date from './date'
import { ArrowRight } from 'react-bootstrap-icons'

const CreateMessageModal = ({
    reflectionPrompt: promptProvided = {},
    onHide,
}) => {
    const {
        saveReflectionPrompt,
        isSavingReflectionPrompt,
        reflectionPrompt,
        setReflectionPrompt
    } = useReflectionPromptMutation({
        onSuccess: onHide,
        reflectionPrompt: promptProvided
    })

    const buttonTitle = isSavingReflectionPrompt ? 'Saving...' : reflectionPrompt.id ? 'Save' : 'Create'

    return createPortal(
        <Modal
            show
            onHide={() => onHide()}
            size='lg'
            backdrop='static'
        >
            <Modal.Header closeButton={!isSavingReflectionPrompt}>
                <Modal.Title>Reflection Prompt</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={reflectionPrompt.name || ''}
                            onChange={e => setReflectionPrompt({ ...reflectionPrompt, name: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows='7'
                            value={reflectionPrompt.description || ''}
                            onChange={e => setReflectionPrompt({ ...reflectionPrompt, description: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Duration</Form.Label>
                        <Row>
                            <Col xs={5}>
                                <Date
                                    value={reflectionPrompt.startDate}
                                    onChange={startDate => setReflectionPrompt({...reflectionPrompt, startDate})}
                                />
                            </Col>
                            <Col xs={2} style={{ textAlign: 'center', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                                <ArrowRight/>
                            </Col>
                            <Col xs={5}>
                                <Date
                                    value={reflectionPrompt.endDate}
                                    onChange={endDate => setReflectionPrompt({...reflectionPrompt, endDate})}
                                />
                            </Col>
                        </Row>
                    </Form.Group>
                </Form>
                <Row>
                    <Col
                        md={{ span: 4, offset: 8}}
                    >
                        <Row>
                            <Col><Button block onClick={() => saveReflectionPrompt()} disabled={isSavingReflectionPrompt}>{buttonTitle}</Button></Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
        , document.body)
}

export default CreateMessageModal